import { Col, Row } from "antd";
import styles from "./ProfileGallery.module.css";
import { SubmitButton, TextComponent } from "../../../components";
import profileGallery1 from "../../../assets/staticImages/profileGallery1.png";
import profileGallery2 from "../../../assets/staticImages/profileGallery2.png";
import profileGallery3 from "../../../assets/staticImages/profileGallery3.png";
import profileGallery4 from "../../../assets/staticImages/profileGallery4.png";
import profileGallery5 from "../../../assets/staticImages/profileGallery5.png";
import profileGallery6 from "../../../assets/staticImages/profileGallery6.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const images = [
  profileGallery1,
  profileGallery2,
  profileGallery3,
  profileGallery4,
  profileGallery5,
  profileGallery6,
];
const icon3 = (
  <svg
    className={styles.image}
    viewBox="0 0 74 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M73.655 45.2082C73.655 42.7115 71.6824 40.6797 69.2569 40.6797H67.0768V16.7076C67.0768 15.656 66.5796 14.7235 65.8148 14.1463L56.0357 4.07729C55.9399 3.93911 55.8321 3.80774 55.7144 3.68591C55.136 3.08693 54.3493 2.75 53.529 2.75H16.0911C13.2386 2.75 10.9182 5.14116 10.9182 8.08024V40.6804H8.72617C6.30139 40.6804 4.32812 42.7115 4.32812 45.2088V68.2376C4.32812 69.0802 4.65337 69.8882 5.23246 70.4837L10.9176 76.3272V77.1018C10.9176 80.0409 13.2379 82.432 16.0904 82.432H61.9033C64.7558 82.432 67.0761 80.0409 67.0761 77.1018V76.3272L72.7612 70.4837C73.4177 69.8092 73.7317 68.8815 73.6543 67.9626V45.2082H73.655Z"
      fill="#DCDCDC"
    />
    <path
      d="M70.1862 42.7492C70.1862 40.2525 68.2136 38.2207 65.7882 38.2207H63.608V14.2493C63.608 13.1977 63.1109 12.2652 62.346 11.688L52.567 1.6183C52.4711 1.48013 52.3634 1.34876 52.2457 1.22692C51.6666 0.627942 50.8799 0.291016 50.0596 0.291016H12.6223C9.76983 0.291016 7.4495 2.68217 7.4495 5.62126V38.2214H5.25742C2.83198 38.2214 0.859375 40.2525 0.859375 42.7492V65.7779C0.859375 66.6205 1.18462 67.4285 1.76371 68.0241L7.44884 73.8675V74.6421C7.44884 77.5812 9.76916 79.9724 12.6216 79.9724H58.4345C61.287 79.9724 63.6074 77.5812 63.6074 74.6421V73.8675L69.2925 68.0241C69.9489 67.3495 70.2629 66.4218 70.1856 65.5029V42.7492H70.1862Z"
      fill="white"
    />
    <path
      d="M10.5276 72.5525L3.9375 65.7793H10.5276V72.5525Z"
      className={styles.fileIcon}
    />
    <path
      d="M60.5234 72.5525L67.1129 65.7793H60.5234V72.5525Z"
      className={styles.fileIcon}
    />
    <path d="M60.522 14.3018H50.0078V3.47656L60.522 14.3018Z" fill="#B1B1B1" />
    <path
      d="M50.0594 3.46289H12.6222C11.4673 3.46289 10.5312 4.42875 10.5312 5.6199V74.6407C10.5312 75.8319 11.4673 76.7978 12.6222 76.7978H58.4351C59.59 76.7978 60.526 75.8319 60.526 74.6407V14.2479H50.0006L50.0594 3.46289Z"
      fill="#F0F0F0"
    />
    <path
      d="M67.1006 65.7785H3.9375V42.749C3.9375 42.001 4.52651 41.3945 5.25301 41.3945H65.7845C66.511 41.3945 67.1 42.001 67.1 42.749V65.7785H67.1006Z"
      className={styles.fileIcon}
    />
    <path
      d="M24.5629 55.1156V59.0001H21.9609V47.9258H26.1752C27.453 47.9258 28.4268 48.2525 29.0964 48.9046C29.7661 49.5573 30.1006 50.4374 30.1006 51.5442C30.1006 52.2337 29.9512 52.8463 29.6517 53.384C29.3523 53.9217 28.9094 54.3451 28.3204 54.6527C27.732 54.9611 27.0167 55.1149 26.1752 55.1149H24.5629V55.1156ZM27.453 51.5448C27.453 50.5729 26.9308 50.0876 25.8863 50.0876H24.5629V52.9701H25.8863C26.9308 52.9701 27.453 52.4944 27.453 51.5448Z"
      fill="white"
    />
    <path
      d="M40.374 56.3299C39.9225 57.1705 39.2734 57.826 38.4272 58.2956C37.5797 58.766 36.5835 59.0008 35.4372 59.0008H31.375V47.9258H35.4372C36.5934 47.9258 37.5923 48.1558 38.4338 48.6153C39.276 49.0747 39.9225 49.7227 40.374 50.5579C40.8249 51.3931 41.051 52.3535 41.051 53.4398C41.0516 54.5261 40.8255 55.4899 40.374 56.3299ZM37.5744 55.7738C38.1377 55.2204 38.4193 54.4424 38.4193 53.4398C38.4193 52.4372 38.1377 51.6592 37.5744 51.1058C37.0119 50.5531 36.2232 50.2754 35.2092 50.2754H33.9769V56.6042H35.2092C36.2239 56.6042 37.0119 56.3278 37.5744 55.7738Z"
      fill="white"
    />
    <path
      d="M49.5445 47.9258V50.0562H45.1332V52.4835H48.5403V54.52H45.1332V59.0001H42.5312V47.9258H49.5445Z"
      fill="white"
    />
    <path
      d="M25.3924 37.1112C24.4623 37.1112 23.7523 36.7314 23.2968 36.1957C22.3184 35.0447 22.5055 33.2158 23.741 31.8477C24.7716 30.7076 27.8046 29.4592 31.2937 28.3926C32.2271 25.8626 33.1347 22.9535 33.8956 20.3663C32.9933 18.114 32.3818 15.5262 32.2443 12.5959C32.1147 9.84197 33.4507 8.27645 34.8376 8.15393C35.9118 8.05932 37.1262 8.86046 37.3688 10.8725C37.4832 11.8206 37.3854 12.8498 37.0799 13.9314L36.6516 15.4758C36.2113 17.0685 35.7605 18.6749 35.3004 20.2513C36.3739 22.7554 37.8296 24.8069 39.3573 26.4031C41.4661 26.0035 43.3032 25.7673 44.3853 25.7748C47.3667 25.7918 48.4879 27.1014 48.8898 27.8808C49.3572 28.7854 49.3122 29.867 48.7715 30.7028C48.197 31.5924 47.1757 32.0594 46.0248 31.9477C44.3761 31.7891 41.56 30.4421 38.8985 27.859C36.795 28.2831 34.4562 28.8589 32.2839 29.4994C31.0861 32.6284 29.8942 34.9583 28.775 35.7744C27.4522 36.7382 26.3139 37.1112 25.3924 37.1112ZM30.6782 29.9936C27.8191 30.9172 25.4724 31.9212 24.7049 32.7706C23.8349 33.7331 23.8362 34.7738 24.2864 35.3041C24.7921 35.8983 26.07 36.0868 28.0135 34.6683C28.8239 34.0775 29.7508 32.2949 30.6782 29.9936ZM40.5499 27.5493C42.7142 29.4586 44.8633 30.4748 46.1464 30.598C46.82 30.6701 47.3694 30.4271 47.6768 29.952C47.9524 29.5253 47.9723 28.9889 47.7283 28.5172C47.2781 27.6446 46.0565 27.1396 44.3774 27.1293C43.4817 27.1198 42.1192 27.2791 40.5499 27.5493ZM34.7246 22.1912C34.1105 24.225 33.4857 26.173 32.8597 27.9346C34.5097 27.4717 36.21 27.0558 37.8064 26.7155C36.6787 25.444 35.6157 23.9377 34.7246 22.1912ZM35.0135 9.50096C34.9923 9.50096 34.9718 9.50232 34.95 9.50436C34.316 9.56086 33.4639 10.5369 33.5585 12.5306C33.6556 14.5834 34.004 16.4614 34.5315 18.1651C34.8687 16.9773 35.1582 15.9271 35.385 15.1062L35.816 13.5536C36.0718 12.6497 36.1545 11.8043 36.0626 11.0399C35.9495 10.0945 35.541 9.50096 35.0135 9.50096Z"
      className={styles.fileIcon}
    />
  </svg>
);

const ProfileGallery = () => {
  const user = useSelector((state) => state.AuthReducer.user);
  console.log("USewr", user);
  const [viewAll, setViewAll] = useState(false);
  const navigate = useNavigate();

  const openDocument = (doc) => {
    const link = document.createElement("a");
    link.href = doc;
    link.target = "_blank";
    // link.download = "Event Timeline"; // specify the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // saveAs(response?.attachment, `${response.title}.pdf`);
  };
  return (
    <>
      <Row
        gutter={[8, 16]}
        style={{ alignItems: "center", justifyContent: "space-between" }}
      >
        <Col xs={24} sm={9} md={10} lg={14} xl={16}>
          <TextComponent textClass={styles.heading}>Gallery</TextComponent>
        </Col>
        <Col xs={24} sm={15} md={14} lg={10} xl={8}>
          <Row gutter={[8, 16]} justify={"end"}>
            <Col xs={24} sm={12}>
              <SubmitButton
                title="Upload Document"
                btnClass={styles.secondaryBtn}
                onClick={() =>
                  navigate("/profile/gallery/uploadDocument", {
                    state: { headrTitle: "Edit Profile" },
                  })
                }
              />
            </Col>
            <Col xs={24} sm={12}>
              <SubmitButton
                title="Upload a Photo"
                onClick={() =>
                  navigate("/profile/gallery/uploadPhoto", {
                    state: { headrTitle: "Edit Profile" },
                  })
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={[16, 20]} className={styles.imgRow}>
        {user?.photos?.length > 0 && (
          <>
            {user?.photos?.map((item, index) => {
              console.log('item',item)
              return (
                <Col key={item.id} xs={24} sm={12} md={8}>
                  {/* <img
                    src={item?.image}
                    alt="Image"
                    style={{ width: "100%" }}
                  /> */}
                  <a href={item?.image}><img src={item?.image}
                    alt="Image"
                    style={{ width: "100%" }}/></a>
                </Col>
              );
            })}
          </>
        )}
      </Row>
      <Col xs={24} sm={9} md={10} lg={14} xl={16}>
        <TextComponent textClass={styles.heading}>Documents</TextComponent>
      </Col>
      <Row gutter={[16, 20]} className={styles.imgRow}>
        {user?.documents?.length > 0 && (
          <>
            {user?.documents?.map((item, index) => {
              return (
                <Col
                  xs={24}
                  sm={12}
                  md={8}
                  className={styles.docCont}
                  key={item.id}
                  onClick={() => openDocument(item?.doc)}
                >
                  {icon3}
                  <TextComponent
                    textClass={styles.docText}
                    text={
                      item?.doc?.split("/")[item?.doc?.split("/").length - 1]
                    }
                  />
                </Col>
              );
            })}
          </>
        )}
      </Row>
      {/* <Row gutter={[16, 20]} className={styles.imgRow}>
        {viewAll
          ? images?.map((img) => (
              <Col xs={24} sm={12} md={8}>
                <img src={img} alt="Image" style={{ width: "100%" }} />
              </Col>
            ))
          : images?.slice(0, 3)?.map((img) => (
              <Col xs={24} sm={12} md={8}>
                <img src={img} alt="Image" style={{ width: "100%" }} />
              </Col>
            ))}
      </Row> */}
      {/* <Row className={styles.btnRow}>
        <Col xs={24} sm={12} lg={8}>
          <SubmitButton
            title={viewAll ? "View Less" : "View More"}
            onClick={() => setViewAll((prev) => !prev)}
          />
        </Col>
      </Row> */}
    </>
  );
};

export default ProfileGallery;
